module.exports = __webpack_public_path__ + "static/media/contra.16c2b6a9.png";